import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";
import moment = require("moment");

/**
 * Appointment list filters (selected dates)
 */
export class AppointmentListFilters {
	constructor(public dateFrom: moment.Moment, public dateTo: moment.Moment) {}

	static default(): AppointmentListFilters {
		return new AppointmentListFilters(moment().startOf("day"), moment().startOf("day"));
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {AppointmentListFilters}
	 */
	static getFromLocalStorageData(data: any): AppointmentListFilters {
		if (!isDefined(data)) {
			return AppointmentListFilters.default();
		}
		return new AppointmentListFilters(data.dateFrom, data.dateTo);
	}

	updateDateFrom(value: moment.Moment): AppointmentListFilters {
		this.dateFrom = value;
		LocalStorage.saveAppointmentListFilters(this);
		return this;
	}

	updateDateTo(value: moment.Moment): AppointmentListFilters {
		this.dateTo = value;
		LocalStorage.saveAppointmentListFilters(this);
		return this;
	}
}
